export default __webpack_public_path__ + "static/media/tkoh.790eee94.PNG";